import { render, staticRenderFns } from "./InputCheckboxSwitch.vue?vue&type=template&id=54b01d68"
import script from "./InputCheckboxSwitch.vue?vue&type=script&lang=ts"
export * from "./InputCheckboxSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports